var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"like-btn",attrs:{"title":_vm.likeTxt}},[_c('a',{class:_vm.cls,attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.addToLikes($event)}}},[_vm._v("\n  "+_vm._s(_vm.likeTxt)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }